<template>
    <div class="question-bank__question-bank-item sm:px-4 px-2 py-6">
        <div class="flex w-full">
            <div class="flex w-full justify-between items-center">
              <div class="question-bank__details">
                  <h5 class="mb-1">{{ data.title }} <span class="text-grey">({{ data.questions_count }} اسئلة)</span></h5>
                  <span v-if="isTeacher">{{ data.course }}</span>
                  <span class="ml-2 text-grey">({{ type }})</span>
                  <span v-if="data.last_updated" class="block mt-1">آخر تعديل: {{data.last_updated | date}}, {{data.last_updated | time}}</span>
              </div>
              <div v-if="!viewOnly && data.type !== 'quiz'" class="flex items-center mr-4">
                <feather-icon @click.stop="$emit('edit', data)" icon="EditIcon" class="hover:text-primary cursor-pointer ml-2" svg-classes="w-5 h-5" />
                <feather-icon @click.stop="$emit('delete', data)" icon="TrashIcon" class="hover:text-danger cursor-pointer ml-2" svg-classes="w-5 h-5" />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
      type() {
          switch (this.data.type) {
              case 'public' : return 'مرئي للطلبة'
              case 'private' : return 'مخفي عن الطلبة'
              case 'quiz' : return 'نموذج إختبار'
              default : return ''
          }
      }
  }
}

</script>

